import apiClient from "./axios"

export const getAccountLoanRepayments = async (params = {}) => {
  const { data } = await apiClient.get("/account-loan-repayments", { params })
  return data
}

export const getAccountLoanRepayment = async id => {
  const { data } = await apiClient.get(`/account-loan-repayments/${id}`)
  return data
}

export const createAccountLoanRepayment = async payload => {
  const { data } = await apiClient.post("/account-loan-repayments", payload)
  return data
}

export const deleteAccountLoanRepayment = async id => {
  const { data } = await apiClient.delete(`/account-loan-repayments/${id}`)
  return data
}
